// extracted by mini-css-extract-plugin
module.exports = {"blockContainer":"v2_blockContainer__McB4I","chrome":"v2_chrome__MmIzz"};